<template>
    <div>
        <h5>
            Bids
            <i v-if="editMode && (!bids || bids.length < 1)" class="fa fa-asterisk small text-danger"></i>
            <span v-else>&nbsp;({{ bids.length }})</span>
            <b-button size="sm" variant="info" title="Add a Bid" v-on:click="newBid" v-if="editMode"><i class="fa fa-plus-circle"></i> Bid</b-button>
        </h5>

        <bid-modal ref="subBidModal" :subcontractorId="subcontractorId" />

        <div v-if="bids.length > 0">
            <b-table bordered striped hover small responsive :items="bids" :fields="fields">
                <template v-slot:cell(bid_id)="data">
                    <button type="button" class="btn btn-sm btn-link" v-on:click="editBid(data.item)" title="Edit Bid"><i class="fa fa-edit"></i></button>
                    <button type="button" class="btn btn-sm btn-link text-danger" v-on:click="deleteBid(data.item)" title="Delete Bid"><i class="fa fa-trash"></i></button>
                </template>
                <template v-slot:cell(bid_project_name)="data">
                    {{ data.item.is_general_bid ? 'General Bid' : data.value }}
                </template>
                <template v-slot:cell(bid_amount)="data">
                    {{ data.value | currency }}
                </template>
                <template v-slot:cell(estimated_date_onsite)="data">
                    <template v-if="data.value">
                    {{ data.value | moment("MM/DD/YYYY") }}
                    </template>
                </template>
                <template v-slot:cell(will_subcontract)="data">
                    {{ data.value == 1 ? 'Yes' : (data.value == 0 ? 'No' : 'N/A') }}
                </template>
            </b-table>
        </div>
        <div v-else>
            -- No Bids Added --
        </div>
    </div>
</template>

<script>
    export default {
        props: {

            editMode: {
                type: Boolean,
                default: false,
            },

            subcontractorId: {
                type: Number,
                required: true,
            }

        },

        data: function() {
            return {
                bids: this.$store.state.subcontractor.bids,
            }
        },

        computed: {
            fields(){
                //Check for edit mode
                if(this.editMode)
                {
                    return [
                        {key:'bid_id', label: 'Actions'},
                        {key:'bid_project_name', label: 'Project'},
                        {key:'bid_amount', label: 'Amount'},
                        {key:'estimated_date_onsite', label: 'Estimated Date OnSite'},
                        {key:'estimator_name', label: this.$store.state.user.account_name+' Contact'},
                        {key:'scope_details', label: 'Details'},
                        {key:'will_subcontract', label: 'Will Subcontract Scope'},
                    ];
                }

                return [
                    {key:'bid_project_name', label: 'Project'},
                    {key:'bid_amount', label: 'Amount'},
                    {key:'estimated_date_onsite', label: 'Estimated Date OnSite'},
                    {key:'estimator_name', label: this.$store.state.user.account_name+' Contact'},
                    {key:'scope_details', label: 'Details'},
                    {key:'will_subcontract', label: 'Will Subcontract Scope'},
                ];
            }
        },

        methods: {

            newBid(){
                //Set the {}}
                this.$refs.subBidModal.setModel({});

                //Activate the modal
                this.$refs.subBidModal.showModal();
            },

            editBid(bid){
                //Set the bid
                this.$refs.subBidModal.setModel(bid);

                //Activate the modal
                this.$refs.subBidModal.showModal();
            },

            deleteBid(bid){
                //Check for confirm
                if(!confirm('Are you sure you want to delete this bid?'))
                {
                    return;
                }

                //Send it
                this.$http
                    .post('/subcontractors/bid/delete/' + bid.bid_id)
                    .then(response => {
                        //Alert
                        this.$toastr.success('Bid Deleted');

                        //Delete the bid
                        //this.updatebids(desig, true);
                        this.$store.commit('deleteBid', bid);
                    });
            },
        },

        mounted() {

        }
    }
</script>